import React, { useState } from "react";
import { Container, DetailSection,
  Title,
  SubTitle,
  InfoBox,
  Details,
  FormSection,
  FormBox,
  FormTitle,
  FormSubTitle,
  RowField,
  InputField,
  TextareaField,
  FormButton,
  Logo
} from "./styled";
import { Col } from "antd";
const costImg = require("../../assets/images/cost.png");
const hourImg = require("../../assets/images/hour.png");

type Props = {
  cost: number;
  hours: number;
  data: any;
};

const Result: React.FC<Props> = ({cost, hours, data}) => {
  const [formData, setFormData]: any = useState(data);

  const setfields = (event: any, fieldName: string) => {
    let value = event.target.value;
    let dummyObj: any = {...formData};
    dummyObj[fieldName] = value;
    setFormData(dummyObj);
  }

  const sendReport = () => {
    var xhr = new XMLHttpRequest();
    var url = 'https://api.hsforms.com/submissions/v3/integration/submit/6062099/75cfdf12-e5ae-4072-9f8d-93e442b3c8bc';

    var fieldsData = {
      "fields": [
        {
          "name": "firstname",
          "value": formData?.firstname
        },
        {
          "name": "lastname",
          "value": formData?.lastname
        },
        {
          "name": "email",
          "value": formData?.email
        },
        {
          "name": "phone",
          "value": formData?.phone
        },
        {
          "name": "total_hours",
          "value": hours
        },
        {
          "name": "total_costs",
          "value": cost
        },
        {
          "name": "what_is_this_website_for_",
          "value": formData?.what_is_this_website_for || ""
        },
        {
          "name": "main_goal_of_the_website",
          "value": formData?.main_goal_of_the_website || ""
        },
        {
          "name": "which_cms",
          "value": formData?.which_cms || ""
        }
      ],
      "context": {
        "pageName": "React App"
      },
    }

    var final_data = JSON.stringify(fieldsData)

    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onreadystatechange = function() {
      if(xhr.readyState == 4 && xhr.status == 200) { 
          let redirectoinUrl = JSON.parse(xhr.responseText).redirectUri;
          window.open(redirectoinUrl);
      } else if (xhr.readyState == 4 && xhr.status == 400){ 
      } else if (xhr.readyState == 4 && xhr.status == 403){ 
      } else if (xhr.readyState == 4 && xhr.status == 404){ 
      }
    }

    xhr.send(final_data);
  }

	return (
		<Container>
      <DetailSection>
        <Title>Based on the answers provided, please find your app development cost estimation below.</Title>
        <SubTitle>Design and development costs for different platforms are comparable. However, choosing two platforms 
          approximately doubles the costs, Startups usually start with one platform where the goal is to validate the idea.
        </SubTitle>

        <InfoBox>
          <Details>
            <div style={{fontWeight: '600', fontSize: '27px'}}>
              <Logo src={costImg} /> Total Cost
            </div>
            <div style={{fontWeight: '700', fontSize: '35px'}}>${cost}</div>
          </Details>
        </InfoBox>

        <InfoBox>
          <Details>
            <div style={{fontWeight: '600', fontSize: '27px'}}>
              <Logo src={hourImg} /> No. of Hours
            </div>
            <div style={{fontWeight: '700', fontSize: '35px'}}>{hours}</div>
          </Details>
        </InfoBox>
      </DetailSection>

      <FormSection>
        <FormBox>
          <FormTitle>Get a full report on your email</FormTitle>
          <FormSubTitle>Share your details below to get the full report over your email.</FormSubTitle>
          <RowField style={{margin: "10px 0 10px 0"}}>
            <Col span={11}>
              <InputField placeholder="First Name" onChange={(e) => setfields(e, "firstname")} />
            </Col>
            <Col span={11} offset={2}>
              <InputField placeholder="Last Name" onChange={(e) => setfields(e, "lastname")} />
            </Col>
          </RowField>
          <RowField>
            <Col span={24}>
              <InputField placeholder="Email Address" onChange={(e) => setfields(e, "email")} />
            </Col>
          </RowField>
          <RowField>
            <Col span={24}>
              <InputField placeholder="Phone Number" onChange={(e) => setfields(e, "phone")} />
            </Col>
          </RowField>
          <RowField>
            <Col span={24}>
              <TextareaField rows={4} maxLength={500} placeholder="Tell us about your project..." />
            </Col>
          </RowField>
          <RowField>
            <Col span={24}>
              <FormButton onClick={sendReport}>Send me my report</FormButton>
            </Col>
          </RowField>
        </FormBox>
      </FormSection>
		</Container>
	);
}

export default Result;